/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type DeleteSourceEnvironmentLinkSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * The kind of source that can be linked to an environment
 */
export const SourceKind = {
  Http: "http",
  Function: "function",
} as const;
/**
 * The kind of source that can be linked to an environment
 */
export type SourceKind = ClosedEnum<typeof SourceKind>;

export type DeleteSourceEnvironmentLinkRequest = {
  /**
   * The kind of source (http or function)
   */
  sourceKind: SourceKind;
  /**
   * The slug of the source
   */
  sourceSlug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteSourceEnvironmentLinkSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteSourceEnvironmentLinkSecurity$outboundSchema: z.ZodMiniType<
  DeleteSourceEnvironmentLinkSecurity$Outbound,
  DeleteSourceEnvironmentLinkSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteSourceEnvironmentLinkSecurityToJSON(
  deleteSourceEnvironmentLinkSecurity: DeleteSourceEnvironmentLinkSecurity,
): string {
  return JSON.stringify(
    DeleteSourceEnvironmentLinkSecurity$outboundSchema.parse(
      deleteSourceEnvironmentLinkSecurity,
    ),
  );
}

/** @internal */
export const SourceKind$outboundSchema: z.ZodMiniEnum<typeof SourceKind> = z
  .enum(SourceKind);

/** @internal */
export type DeleteSourceEnvironmentLinkRequest$Outbound = {
  source_kind: string;
  source_slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteSourceEnvironmentLinkRequest$outboundSchema: z.ZodMiniType<
  DeleteSourceEnvironmentLinkRequest$Outbound,
  DeleteSourceEnvironmentLinkRequest
> = z.pipe(
  z.object({
    sourceKind: SourceKind$outboundSchema,
    sourceSlug: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sourceKind: "source_kind",
      sourceSlug: "source_slug",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteSourceEnvironmentLinkRequestToJSON(
  deleteSourceEnvironmentLinkRequest: DeleteSourceEnvironmentLinkRequest,
): string {
  return JSON.stringify(
    DeleteSourceEnvironmentLinkRequest$outboundSchema.parse(
      deleteSourceEnvironmentLinkRequest,
    ),
  );
}
